module.exports = __webpack_public_path__ + "static/media/9DESA6.e6b107d6.jpg";